import { takeLatest, put, select } from 'redux-saga/effects';
import { StatusUpdatesAPI } from 'api/status-updates';
import { logger } from 'services';
import { updateStatusUpdateTitle } from '../actions';
import { selectActiveStatusUpdate, updateStatusUpdate } from '../slice';
function* updateStatusUpdateTitleManager(action) {
    const { payload } = action;
    try {
        const statusUpdate = yield select(selectActiveStatusUpdate);
        if (statusUpdate !== null) {
            const response = yield StatusUpdatesAPI.updateStatusUpdate({
                ...statusUpdate,
                statusUpdateTitle: payload.statusUpdateTitle
            });
            yield put(updateStatusUpdate(response));
            yield payload.onSuccess && payload.onSuccess(response);
        }
    } catch (error) {
        logger.error('Error updating status update title', {
            error
        });
    }
}
export const watchUpdateStatusUpdateTitle = function*() {
    yield takeLatest(updateStatusUpdateTitle.type, updateStatusUpdateTitleManager);
};
